import state from "./state";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

/**
 * Módulo Vuex "relatoOcorrencia/visualizacao" (namespaced).
 * Gerencia o estado da ocorrência selecionada na listagem para a tela de visualização.
 * Responsável apenas por armazenar o item selecionado; busca de detalhes e adaptação
 * ficam a cargo do container VisualizarRelatoOcorrenciaContainer.vue.
 *
 * @module relatoOcorrencia/visualizacao
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
